import loadable from '@loadable/component'

export default [
  {
    path: '/game/GreedyBox',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-GreedyBox" */ '~/pages/game/GreedyBox'
        )
    ),
  },
]
